export default __webpack_public_path__ + "static/images/pc.b241d3fd.png";